var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Spinner, Flex, Heading, Icon, Text } from "@springcare/sh-component-library";
import { useMember } from "shared/hooks";
import { IFrameWarning } from "shared/features/iframe-page";
import { Ellipse } from "shared/assets/icons";
import { getAgeFromFormattedDob } from "shared/utils";
export var PrescriptionsIFrameHeader = function (_a) {
    var _b;
    var memberId = _a.memberId;
    if (!memberId)
        return _jsx(_Fragment, {});
    var _c = useMember(memberId), data = _c.data, isLoading = _c.isLoading, isError = _c.isError, error = _c.error;
    if (isError) {
        return _jsx("div", { children: error });
    }
    if (isLoading) {
        return (_jsx(Box, { children: _jsx(Spinner, { "data-testid": "loading" }) }));
    }
    var member = data;
    var age = getAgeFromFormattedDob((_b = member === null || member === void 0 ? void 0 : member.date_of_birth) !== null && _b !== void 0 ? _b : '');
    return (_jsxs(_Fragment, { children: [_jsxs(Flex, __assign({ direction: "row", bgColor: "white" }, { children: [_jsx(Heading, __assign({ size: "h3" }, { children: "".concat(member === null || member === void 0 ? void 0 : member.first_name, " ").concat(member === null || member === void 0 ? void 0 : member.last_name) })), _jsx(Icon, { as: Ellipse, boxSize: 4, ml: 4, mt: 3 }), _jsxs(Text, __assign({ size: "small", mt: 2 }, { children: [member === null || member === void 0 ? void 0 : member.date_of_birth, " (", age, " yo)"] }))] })), _jsx(IFrameWarning, { children: "All changes must be saved within this window before closing." })] }));
};
